<template>
    <span id="modals-endofgame-statistics">
        <b-modal id="modal-game-statistics" :title="__('results.game_results')" @hidden="backToMatchmaking" size="xl">
            <div class="results">
                 <template v-if="players">
                    <template v-if="players.length <= 2">
                        <game-asset-v-2-score-player
                            v-for="player, idx in players"
                            :playerIndex="idx"
                            :playerId="player.player_id"
                            :key="idx">
                        </game-asset-v-2-score-player>
                    </template>
                    <template v-else>
                        <div class="small-player-scores-row">
                            <game-asset-v-2-score-player
                                v-for="player, idx in players"
                                :playerIndex="idx"
                                :playerId="player.player_id"
                                :smallscores = "true"
                                :key="idx">
                            </game-asset-v-2-score-player>
                        </div>
                    </template>
                </template>
            </div>
            <div class="history-changer">
                <a href="#" @click="changeLeg(-1)"><i class="fas fa-backward"></i> {{__('results.leg_back')}}</a>
                <div class="stats">{{__('results.set')}} {{currentSet}} {{__('results.leg')}} {{currentLeg}}</div>
                <a href="#" @click="changeLeg(+1)"> {{__('results.leg_next')}} <i class="fas fa-forward"></i></a>
            </div>
            <div class="stats-toggle row">
                <div class="col-12 text-center p-2">
                    <button type="button" class="btn btn-primary" @click="statsToggle('history')">
                        <i class="fas fa-poll-h"></i>
                        {{__('results.history')}}
                    </button>
                    <button type="button" class="btn btn-info" @click="statsToggle('legstats')">
                        <i class="fas fa-poll"></i>
                        {{__('results.leg_statistics')}}
                    </button>
                    <button type="button" class="btn btn-info" @click="statsToggle('gamestats')">
                        <i class="fas fa-poll"></i>
                        {{__('results.game_statistics')}}
                    </button>
                </div>
            </div>
            <div class="history-legs shadow-light" v-if="showDetails('history')">
                <game-asset-game-history-v-2 v-if="useHistory == 'default'"></game-asset-game-history-v-2>
                <game-asset-v-3-history-flowliga v-if="useHistory == 'flowliga'"></game-asset-v-3-history-flowliga>
            </div>
            <div class="statistics shadow-light"  v-if="showDetails('legstats')">
                <div class="statistics-container mt-2">
                    <h3 class="statistics-game-header">{{__("results.leg_statistics")}}</h3>
                    <div class="playernames">
                        <div class="playername" v-for="player, idx in players" :key="idx">{{player.name}}</div>
                    </div>
                    <div class="stats-player-container">
                        <div class="stats-unit" v-for="stats in playerlegstats" :key="stats.player_id">
                            <div class="stat chartstat" v-if="stats.chart">
                                <canvas :id="`chart_${stats.player_id}`" :ref="`chart_leg_${stats.player_id}`"></canvas>
                            </div>
                            <div class="stat" v-for="stat, key in stats['datapoints']" :key="stats.player_id + '-' + key">
                                <div class="label" v-html="__('statistics.'+key)"></div>
                                <div class="value" v-html="stat"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="statistics shadow-light"  v-if="showDetails('gamestats')">
                <div class="statistics-container mt-2">
                    <h3 class="statistics-game-header">{{__("results.game_statistics")}}</h3>
                    <div class="playernames">
                        <div class="playername" v-for="player, idx in players" :key="idx">{{player.name}}</div>
                    </div>
                    <div class="stats-player-container">
                        <div class="stats-unit" v-for="stats in playerstats" :key="stats.player_id">
                            <heatmap-dartboard :hits="stats['datapoints']['heatmap_hits']" v-if="stats['datapoints']['heatmap_hits']"></heatmap-dartboard>
                            <div class="stat chartstat" v-if="stats.chart">
                                <canvas :id="`chart_${stats.player_id}`" :ref="`chart_game_${stats.player_id}`"></canvas>
                            </div>
                            <div class="stat" v-for="stat, key in stats['datapoints']" :key="stats.player_id + '-' + key">
                                <template v-if="key != 'heatmap_hits'">
                                    <div class="label" v-html="__('statistics.'+key)"></div>
                                    <div class="value" v-html="stat"></div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer class="d-flex">
                <div class="ml-auto mt-4">
                    <b-button
                        variant="danger"
                        size="lg"
                        class="float-right ml-2"
                        @click="backToMatchmaking"
                        v-html="__('results.back_to_matchmaking')"
                    >
                    </b-button>
                </div>
            </template>
        </b-modal>
    </span>
</template>

<script>
    import HeatmapDartboard from '../charts/HeatmapDartboard.vue'
    import * as chart from '../charts/LegStatsChart'
    export default {
        components: { HeatmapDartboard },
        props: ['game_prop', 'replaceHistory'],
        data() {
            return {
                game: this.game_prop,
                players: null,
                endOfLeg: false,
                endOfGame: false,

                playerstats: [],
                playerlegstats: [],
                charts: [],
                currentLeg: 0,
                currentSet: 0,
                legIndex: 0,

                showStat: 'history',
                useHistory: 'default',
            }
        },
        mounted() {
            window.connection.subscribe(this);
            this.update(window.connection.lastUpdate);
            if (this.replaceHistory) {
                this.useHistory = this.replaceHistory;
            }
        },
        methods: {
            update(data) {
                if (data == null) return;
                //update players from gamestate
                if (this.players == null) {
                    this.players = data.players;
                }
                if (data.action == "endOfLeg") {
                    this.endOfLeg = true;
                    setTimeout(() => {
                        this.$bvModal.show('modal-leg-end');
                    }, 250);
                }

                if (data.action == "newLegStart") {
                    this.endOfLeg = false;
                }

                this.endOfGame = true;
                this.$bvModal.show('modal-game-statistics');

                this.playerstats = data.gameStats.results;
                this.playerlegstats = data.legStats.data;
                this.currentLeg = data.legStats.currentLeg;
                this.currentSet= data.legStats.currentSet;
                this.legIndex = data.legStats.legIndex;
                this.drawCharts();
            },
            statsToggle(show) {
                this.showStat = show;
                this.drawCharts();
            },
            showDetails(show) {
                return this.showStat == show;
            },
            backToMatchmaking() {
                axios.post("/gotourl", {url: "/dashboard/"});
            },
            drawCharts() {
                this.charts.forEach(chart => {
                    chart.destroy();
                });
                this.charts = [];
                setTimeout(() => {
                    if (this.showStat == 'gamestats') {
                        this.playerstats.forEach(stats => {
                            if (stats.chart) {
                                this.charts.push(chart.drawChart(
                                    this.$refs[`chart_game_${stats.player_id}`],
                                    stats.chart.rounds || stats.chart.points.length,
                                    stats.chart.points,
                                    stats.chart.scores,
                                ));
                            }
                        });
                    }
                    if (this.showStat == 'legstats') {
                        this.playerlegstats.forEach(stats => {
                            if (stats.chart) {
                                this.charts.push(chart.drawChart(
                                    this.$refs[`chart_leg_${stats.player_id}`],
                                    stats.chart.rounds || stats.chart.points.length,
                                    stats.chart.points,
                                    stats.chart.scores,
                                ));
                            }
                        });
                        console.log(this.charts);
                    }
                }, 100);
            },
            changeLeg(change) {
                axios.post("/api/stats/changeleg", {game: this.game.id, legIndex: parseInt(this.legIndex)+change});
            }
        }
    }
</script>
